import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { AuthState } from '@/store/auth';
import { Team } from '@/classes/auth';

@Component({
  computed: {
    ...mapState<AuthState>('auth', {
      team: (state: AuthState) => new Team(state.team),
    }),
  },
})
export class ABTestMixins extends Vue {
  team!: Team;

  isOnABTest(abTestName: string): boolean {
    return Boolean(this.team.ab_tests.length && this.team.ab_tests.includes(abTestName));
  }
}
